import LogSearch from './LogSearch';

export default function CloudwatchLogs() {
    return <LogSearch defaultPattern="cwlogs-*" lockPattern={true} title="Cloudwatch Logs" defaultHours={1} />;
}
